import { Stack, styled } from '@mui/material'
import TraineeCertifications from './components/certifications/TraineeCertifications'
import TraineeInformation from './components/information/TraineeInformation'

const Trainee = () => {
	return (
		<Container>
			<TraineeInformation />
			<TraineeCertifications />
		</Container>
	)
}

const Container = styled(Stack)({
	columnGap: '24px',
	flex: 1,
	flexDirection: 'row',
	minHeight: 0
})

export default Trainee
